import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button, Modal } from 'react-bootstrap';
import { TiThMenu } from "react-icons/ti";
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ContactUsSection from './ContactUsSection';

const CustomNavbar = () => {
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [showMenuModal, setShowMenuModal] = useState(false);
  const [showContactModal, setShowContactModal]=useState(false);
  
  const handleShowMenuModal = () => setShowMenuModal(true);
  const handleCloseMenuModal = () => setShowMenuModal(false);
  const handleShowContactModal = () => setShowContactModal(true);
  const handleCloseContactModal = () => setShowContactModal(false);

  

  useEffect(() => {

    const handleScroll = () => {
      if (window.scrollY > lastScrollY && window.scrollY > 50) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <Navbar
      expand="lg"
      className={`shadow-sm ${showNavbar ? 'd-block' : 'd-none'} fixed-top`}
      style={{ backgroundColor: 'rgba(84, 83, 83, 0.8)', backdropFilter: 'blur(10px)' }}
    >
      <Container>

        <Navbar.Brand as={Link} to='/'>
          <img
            src="/assets/images/logo.png" 
            alt="Logo"
            style={{ height: '40px' }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto d-flex gap-3">
                <Nav.Link as={Link} to='/ourTeam' className='letter-spacing text-white'>OUR TEAM</Nav.Link>
                <Nav.Link as={Link} to='/inTheNews' className='letter-spacing text-white'>PRESS</Nav.Link>
                <Nav.Link as={Link} to='/listFeaturedProperties' className='letter-spacing text-white'>FEATURED HOMES</Nav.Link>
                <Nav.Link as={Link} to='/soldHomes' className='letter-spacing text-white'>HOMES SOLD BY SWG</Nav.Link>
                <Nav.Link href="#contact-us" className='letter-spacing text-white' onClick={handleShowContactModal}>CONTACT US</Nav.Link>
              </Nav>

          <Button variant='transparent' className="ms-2"  onClick={handleShowMenuModal}>
            <TiThMenu className='text-white'/>
          </Button>
        </Navbar.Collapse>

        {/* Modal for ContactUsSection */}
      <Modal show={showContactModal} onHide={handleCloseContactModal} fullscreen>
        <Modal.Header closeButton>
        <h1 className="ms-5">Contact Us</h1>
        </Modal.Header>
        <Modal.Body>
          <ContactUsSection />
        </Modal.Body>
        
      </Modal>


        <Modal
        show={showMenuModal}
        onHide={handleCloseMenuModal}
        fullscreen
        aria-labelledby="menu-modal"
        className="menu-modal bg-black"
      >
        <Modal.Header className="bg-black/80 text-white" closeButton>
          <Modal.Title id="menu-modal"  className="text-center w-100">
          <h2>Shelton Wilder Group</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column align-items-center justify-content-center bg-black/80 text-white">
          <div className="container">
            
            
              <div className=" text-right">
                <ul className="list-unstyled">
                <li className="mb-3">
                    <Link to="/" className="text-decoration-none menuText2 text-white fs-3 " onClick={handleCloseMenuModal}>
                      <h1>Home</h1>
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/aboutInfo" className="text-decoration-none menuText2 text-white fs-3" onClick={handleCloseMenuModal}>
                      <h1>About Us</h1>
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/ourTeam" className="text-decoration-none menuText2 text-white fs-3" onClick={handleCloseMenuModal}>
                      <h1>Our Team</h1>
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/inTheNews" className="text-decoration-none menuText2 text-white fs-3" onClick={handleCloseMenuModal}>
                      <h1>Press</h1>
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/listFeaturedProperties" className="text-decoration-none menuText2 text-white fs-3" onClick={handleCloseMenuModal}>
                      <h1>Featured Homes</h1>
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/soldHomes" className="text-decoration-none menuText2 text-white fs-3" onClick={handleCloseMenuModal}>
                      <h1>Sold Homes</h1>
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link href="#" className="text-decoration-none menuText2 text-white fs-3" onClick={handleShowContactModal}>
                      <h1>Contact Us</h1>
                    </Link>
                  </li>
                  
                </ul>
              </div>
            </div>
          
        </Modal.Body>
      </Modal>

      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
